import { useState } from "react";
import { Modal } from "react-bootstrap";
import Service from "../../Service/http";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";

export default function CreateBatchModal({ show, onHide, criteriaOptions }) {

    /* ---------------- States -------------------- */
    
    const [ batchName, setBatchName ] = useState('');
    const [ criteria, setCriteria ] = useState('');
    const [ startTime, setStartTime ] = useState('')
    const [ endTime, setEndTime ] = useState('')

    /* --------------- constants ------------------- */

    const service = new Service();

    /* ---------------- functions ------------------- */

    const createBatch = async () => {

        const response = await service.post('api/addBatch', { batchName, criteria, startTime, endTime });
        return response;

    }

    const { mutate, isLoading: loading } = useMutation(["addBatch"], createBatch, {
        onSuccess(json) {
            toast.success(json.message);
            setBatchName('');    
            setCriteria('');
            setStartTime('');
            setEndTime('');
            onHide()
        },
        onError(json) {
            toast.error("Some Error Occurred!")
        },
    })

    const handleSubmit = async () => {

        if(!batchName || !criteria || !startTime || !endTime) {
            toast.error('All Fields are Required!');
            return;
        }

        if(new Date(startTime) > new Date(endTime)) {
            toast.error("Start Time Must Be Smaller Than End Time");
            return;
        }

        mutate()
    }

    /* ------------- UI Components ----------------- */
    return (
        <Modal show={show} onHide={onHide} backdrop="static" keyboard={false}>
            <Modal.Header >
                <Modal.Title>
                    <h4 className="text-primary">Create New Batch !</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                
                <label htmlFor="batchName">Batch Name <span className="text-danger">*</span></label>
                <input 
                    type="text" 
                    required id="batchName" 
                    className="form-control text-primary my-1"
                    onChange={(e) => setBatchName(e.target.value)}
                    value={batchName}
                />
                <label htmlFor="startTime">Criteria <span className="text-danger">*</span> </label>
                <select id="criteria" className="form-select text-primary my-2" onChange={(e) => setCriteria(e.target.value)} value={criteria}>
                    <option value="">Select Criteria</option>
                    {
                        criteriaOptions && criteriaOptions.map((criteria) => {
                            return <option value={criteria}>{criteria}</option>
                        } )
                    }
                </select>
                <label htmlFor="startTime">Start Time <span className="text-danger">*</span> </label>
                <input
                    className="form-control text-primary my-2"
                    id="startTime"
                    required
                    type="datetime-local"
                    onChange={(e) => setStartTime(e.target.value)}
                    value={startTime}
                />
                <label htmlFor="endTime">End Time <span className="text-danger">*</span> </label>
                <input 
                    type="datetime-local" 
                    id="endTime" 
                    className="form-control text-primary my-2"
                    onChange={(e) => setEndTime(e.target.value)}
                    value={endTime}
                />

            </Modal.Body>
            <Modal.Footer>
                <button className="custom-button text-dark" onClick={onHide}>
                    Close
                </button>
                <button className="custom-button text-white bg-success" onClick={handleSubmit}>
                    { loading ? <ClipLoader size={15} color="white" /> : "Create" }
                </button>
            </Modal.Footer>
      </Modal>
    );
  }